import React from "react";

export default function PaymentMethodList({
  methods = [],
  selectedId,
  onSelect,
  onMakeDefault, // NEW PROP
}) {
  return (
    <div className="space-y-3">
      {methods?.length === 0 && (
        <div className="text-sm text-gray-500">
          No saved cards available. Use "Add New Card" to add one.
        </div>
      )}

      {methods?.map((m) => (
        <div
          key={m._id}
          onClick={() => onSelect && onSelect(m._id)}
          className={`flex items-center justify-between p-4 rounded-lg border cursor-pointer shadow-sm transition-all 
            ${
              selectedId === m._id
                ? "border-indigo-500 bg-indigo-50 shadow-md"
                : "border-gray-200 bg-white hover:shadow-md hover:border-gray-300"
            }
          `}
        >
          {/* LEFT */}
          <div>
            <div className="font-semibold text-gray-800 flex items-center gap-2">
              {m.brand?.toUpperCase() || "Card"} •••• {m.last4}
              {m.isDefault && (
                <span className="px-2 py-0.5 text-xs rounded bg-green-100 text-green-700">
                  Default
                </span>
              )}
            </div>

            <div className="text-xs text-gray-500">
              Expires {m.expMonth}/{m.expYear}
            </div>
          </div>

          {/* RIGHT — Actions */}
          <div className="flex items-center gap-2">
            {/* Default Button: show only if NOT default */}
            {!m.isDefault && (
              <button
                onClick={(e) => {
                  e.stopPropagation(); // prevent triggering card select
                  onMakeDefault && onMakeDefault(m._id);
                }}
                className="px-2 py-1 text-xs rounded bg-gray-100 hover:bg-gray-200 text-gray-700"
              >
                Make Default
              </button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
